import { createFileRoute } from "@tanstack/react-router";

import { SupportSettingsPanel } from "../components/settings/SupportLegalSettings";

export const Route = createFileRoute("/settings/support")({
  component: SupportSettingsPanel,
});
